// extracted by mini-css-extract-plugin
export var body = "_23-8";
export var button = "_23-0";
export var closeButton = "_23-5";
export var content = "_23-3";
export var empty = "_23-f";
export var grid = "_23-c";
export var header = "_23-4";
export var icon = "_23-1";
export var option = "_23-d";
export var optionSelected = "_23-e";
export var overlay = "_23-2";
export var searchIcon = "_23-a";
export var searchInput = "_23-b";
export var searchWrapper = "_23-9";
export var title = "_23-6";
export var visuallyHidden = "_23-7";